import {
    software_account_aggregation,
    software_accounting,
    software_crm,
    software_document_management,
    software_financial_planning,
    software_portfolio_rebalancing
} from '../data/data';

export default {
    "section": "Section 3: Technology",
    "name": "technology",
    "items": [
        {
            "text": "CRM Software Used",
            "type": "selectlist",
            "name": "technology-crm-software",
            "props": {
                "items": [],
                "label": "Please select an option"
            },
            "subItems": [
                {
                    "text": "Name of other software",
                    "type": "text-field",
                    "name": "technology-crm-software-other",
                    "props": {
                        "label": "Please enter the name of your other software"
                    },
                    "dependencies": {
                        "items": [
                            {
                                "name": "technology-crm-software",
                                "value": "7"
                            }
                        ]
                    }
                },
                {
                    "text": "Please rate your usage/proficiency",
                    "type": "slider",
                    "name": "technology-crm-software-proficiency",
                    "props": {
                        "labels": [
                            "Not at all",
                            "undefined",
                            "undefined",
                            "undefined",
                            "undefined",
                            "Extremely Proficient"
                        ]
                    },
                    "dependencies": {
                        "items": [
                            {
                                "name": "technology-crm-software",
                                "operator": "notEqual",
                                "value": "0"
                            },
                            {
                                "name": "technology-crm-software",
                                "operator": "isDefined"
                            }
                        ]
                    }
                }
            ]
        },
        {
            "text": "Financial Planning Software Used",
            "type": "selectlist",
            "name": "technology-financial-planning-software",
            "props": {
                "items": [],
                "label": "Please select an option"
            },
            "subItems": [
                {
                    "text": "Name of other software",
                    "type": "text-field",
                    "name": "technology-financial-planning-software-other",
                    "props": {
                        "label": "Please enter the name of your other software"
                    },
                    "dependencies": {
                        "items": [
                            {
                                "name": "technology-financial-planning-software",
                                "value": "7"
                            }
                        ]
                    }
                },
                {
                    "text": "Please rate your usage/proficiency",
                    "type": "slider",
                    "name": "technology-financial-planning-software-proficiency",
                    "props": {
                        "labels": [
                            "Not at all",
                            "undefined",
                            "undefined",
                            "undefined",
                            "undefined",
                            "Extremely Proficient"
                        ]
                    },
                    "dependencies": {
                        "items": [
                            {
                                "name": "technology-financial-planning-software",
                                "operator": "notEqual",
                                "value": "0"
                            },
                            {
                                "name": "technology-financial-planning-software",
                                "operator": "isDefined"
                            }
                        ]
                    }
                }
            ]
        },
        {
            "text": "Portfolio Rebalancing Software Used",
            "type": "selectlist",
            "name": "technology-portfolio-rebalancing-software",
            "props": {
                "items": [],
                "label": "Please select an option"
            },
            "subItems": [
                {
                    "text": "Name of other software",
                    "type": "text-field",
                    "name": "technology-portfolio-rebalancing-software-other",
                    "props": {
                        "label": "Please enter the name of your other software"
                    },
                    "dependencies": {
                        "items": [
                            {
                                "name": "technology-portfolio-rebalancing-software",
                                "value": "9"
                            }
                        ]
                    }
                },
                {
                    "text": "Please rate your usage/proficiency",
                    "type": "slider",
                    "name": "technology-portfolio-rebalancing-software-proficiency",
                    "props": {
                        "labels": [
                            "Not at all",
                            "undefined",
                            "undefined",
                            "undefined",
                            "undefined",
                            "Extremely Proficient"
                        ]
                    },
                    "dependencies": {
                        "items": [
                            {
                                "name": "technology-portfolio-rebalancing-software",
                                "operator": "notEqual",
                                "value": "0"
                            },
                            {
                                "name": "technology-portfolio-rebalancing-software",
                                "operator": "isDefined"
                            }
                        ]
                    }
                }
            ]
        },
        {
            "text": "Document Management Software Used",
            "type": "selectlist",
            "name": "technology-document-management-software",
            "props": {
                "items": [],
                "label": "Please select an option"
            },
            "subItems": [
                {
                    "text": "Name of other software",
                    "type": "text-field",
                    "name": "technology-document-management-software-other",
                    "props": {
                        "label": "Please enter the name of your other software"
                    },
                    "dependencies": {
                        "items": [
                            {
                                "name": "technology-document-management-software",
                                "value": "8"
                            }
                        ]
                    }
                },
                {
                    "text": "Please rate your usage/proficiency",
                    "type": "slider",
                    "name": "technology-document-management-software-proficiency",
                    "props": {
                        "labels": [
                            "Not at all",
                            "undefined",
                            "undefined",
                            "undefined",
                            "undefined",
                            "Extremely Proficient"
                        ]
                    },
                    "dependencies": {
                        "items": [
                            {
                                "name": "technology-document-management-software",
                                "operator": "notEqual",
                                "value": "0"
                            },
                            {
                                "name": "technology-document-management-software",
                                "operator": "isDefined"
                            }
                        ]
                    }
                }
            ]
        },
        {
            "text": "Account Aggregation Software Used",
            "type": "selectlist",
            "name": "technology-account-aggregation-software",
            "props": {
                "items": [],
                "label": "Please select an option"
            },
            "subItems": [
                {
                    "text": "Name of other software",
                    "type": "text-field",
                    "name": "technology-account-aggregation-software-other",
                    "props": {
                        "label": "Please enter the name of your other software"
                    },
                    "dependencies": {
                        "items": [
                            {
                                "name": "technology-account-aggregation-software",
                                "value": "7"
                            }
                        ]
                    }
                },
                {
                    "text": "Please rate your usage/proficiency",
                    "type": "slider",
                    "name": "technology-account-aggregation-software-proficiency",
                    "props": {
                        "labels": [
                            "Not at all",
                            "undefined",
                            "undefined",
                            "undefined",
                            "undefined",
                            "Extremely Proficient"
                        ]
                    },
                    "dependencies": {
                        "items": [
                            {
                                "name": "technology-account-aggregation-software",
                                "operator": "notEqual",
                                "value": "0"
                            },
                            {
                                "name": "technology-account-aggregation-software",
                                "operator": "isDefined"
                            }
                        ]
                    }
                }
            ]
        },
        {
            "text": "Accounting Software Used",
            "type": "selectlist",
            "name": "technology-accounting-software",
            "props": {
                "items": [],
                "label": "Please select an option"
            },
            "subItems": [
                {
                    "text": "Name of other software",
                    "type": "text-field",
                    "name": "technology-accounting-software-other",
                    "props": {
                        "label": "Please enter the name of your other software"
                    },
                    "dependencies": {
                        "items": [
                            {
                                "name": "technology-accounting-software",
                                "value": "8"
                            }
                        ]
                    }
                },
                {
                    "text": "Please rate your usage/proficiency",
                    "type": "slider",
                    "name": "technology-accounting-software-proficiency",
                    "props": {
                        "labels": [
                            "Not at all",
                            "undefined",
                            "undefined",
                            "undefined",
                            "undefined",
                            "Extremely Proficient"
                        ]
                    },
                    "dependencies": {
                        "items": [
                            {
                                "name": "technology-accounting-software",
                                "operator": "notEqual",
                                "value": "0"
                            },
                            {
                                "name": "technology-accounting-software",
                                "operator": "isDefined"
                            }
                        ]
                    }
                }
            ]
        },
        {
            "text": "Please list other technologies used and their purpose",
            "type": "textarea",
            "name": "technology-other-technologies"
        },
        {
            "text": "Are you a paperless office?",
            "type": "slider",
            "name": "technology-paperless-office",
            "props": {
                "label": "Please rate how much.",
                "labels": [
                    "Not at all",
                    "undefined",
                    "undefined",
                    "undefined",
                    "undefined",
                    "100% Paperless"
                ]
            }
        }
    ]
};


// WEBPACK FOOTER //
// ./src/components/valuation/valuation-data/technology.js